<template>
  <InteractionStep
                   :disabled-next="!arrival"
                   :pending-next="pendingSave"
                   @next="onSave">

    <template v-slot:content>
      <div class="step-text">
        <div v-if="arrival_info"
             class="step-text__text text"
             style="font-size: 1.5rem">
          <p>{{ $tInteraction('Applicant will arrive') }}
            <template v-if="address">{{ $tInteraction('at') }}</template>
            {{ address }} {{ dateString }}
            <template v-if="timeString">{{ $tInteraction('to') }}</template>
            {{ timeString }}
          </p>
          <p>{{ $tInteraction('Confirm the arrival text') }}</p>
        </div>

        <div class="step-text__options step-options">
          <div class="step-options__inner">
            <label class="step-options__item"
                   :class="{ _disabled: !isActive }">
              <input
                  type="checkbox"
                  name="type-option"
                  hidden
                  :input="arrival"
                  @input="isActive ? (arrival = $event) : null"
              >
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <span
                  class="step-options__item-inner"
              >
                <span v-if="isActive">{{ $tInteraction('Arrived') }}</span>
                <span v-else>{{ $tInteraction('Waiting') }}...</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '../../../axios'
  import InteractionStep from '../InteractionStep'
  import parseDateForLocal from "../../../helpers/parseDateForLocal"
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  let timer

  export default {
    mixins: [interactionStepMixin],
    components: {
      InteractionStep
    },
    data() {
      return {
        pendingSave: false,
        error: null,
        arrival: false,
        arrival_info: null,
        currentTime: new Date()
      }
    },
    computed: {
      date() {
        if (!this.arrival_info) return
        return parseDateForLocal(this.arrival_info.data)
        // d.setHours(this.arrival_info.time_hours)
        // d.setMinutes(this.arrival_info.time_minutes)
        // return d
      },
      isActive() {
        if (!this.date) return false;

        return new Date(this.currentTime) >= new Date(this.date)
      },
      dateString() {
        const date = this.date
        if (!date) return

        return this.date.toLocaleDateString()
      },
      timeString() {
        const date = this.date
        if (!date) return
        return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
      },
      address() {
        const a = [this.arrival_info.city, this.arrival_info.street_name, this.arrival_info.street_number]
        return a.filter(a => a).join(', ')
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    },
    created() {
      this.arrival_info = this.$store.state.interaction.stepData.arrival_date
          || this.$store.state.interaction.stepData.data.arrival_info

      timer = setInterval(() => {
        this.currentTime = new Date()
      }, 10000)
    },
    beforeDestroy() {
      clearInterval(timer)
    }
  }
</script>

<style>

</style>
